var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowRight = function SvgArrowRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.48a.8.8 0 0 0-.07-.34.8.8 0 0 0-.19-.28l-4.37-4.37a.88.88 0 0 0-1.24 1.24L12 6.6H.88a.88.88 0 0 0 0 1.76H12l-2.9 2.91a.86.86 0 0 0 0 1.24.87.87 0 0 0 1.24 0l4.37-4.36A.9.9 0 0 0 15 7.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export default ForwardRef;